/**
 * LinkHub API Service
 */

import { apiClient } from "./client";
import type {
  CreateLinkDto,
  CreateLinkGroupDto,
  Link,
  LinkGroup,
  LinkHubManageResponse,
  LinkHubPublicResponse,
  ReorderLinkhubDto,
  UpdateLinkDto,
  UpdateLinkGroupDto,
} from "@/types";

export const linkhubService = {
  async getPublicBySlug(slug: string): Promise<LinkHubPublicResponse> {
    return apiClient.get<LinkHubPublicResponse>(
      `/tenants/public/${encodeURIComponent(slug)}/linkhub`,
    );
  },

  async getMine(): Promise<LinkHubManageResponse> {
    return apiClient.get<LinkHubManageResponse>("/tenants/me/linkhub");
  },

  async createGroup(body: CreateLinkGroupDto): Promise<LinkGroup> {
    return apiClient.post<LinkGroup>("/tenants/me/linkhub/groups", body);
  },

  async updateGroup(id: string, body: UpdateLinkGroupDto): Promise<LinkGroup> {
    return apiClient.patch<LinkGroup>(`/tenants/me/linkhub/groups/${id}`, body);
  },

  async deleteGroup(id: string): Promise<LinkGroup> {
    return apiClient.delete<LinkGroup>(`/tenants/me/linkhub/groups/${id}`);
  },

  async createLink(groupId: string, body: CreateLinkDto): Promise<Link> {
    return apiClient.post<Link>(
      `/tenants/me/linkhub/groups/${groupId}/links`,
      body,
    );
  },

  async updateLink(id: string, body: UpdateLinkDto): Promise<Link> {
    return apiClient.patch<Link>(`/tenants/me/linkhub/links/${id}`, body);
  },

  async deleteLink(id: string): Promise<Link> {
    return apiClient.delete<Link>(`/tenants/me/linkhub/links/${id}`);
  },

  async reorder(body: ReorderLinkhubDto): Promise<LinkHubManageResponse> {
    return apiClient.patch<LinkHubManageResponse>(
      "/tenants/me/linkhub/reorder",
      body,
    );
  },
};
